// @ts-nocheck
import React from 'react';

type Props = {
  variant: 'correct' | 'wrong' | null;
};

/**
 * Lớp phủ toàn màn: flash + hạt + thông điệp khi đúng/sai (pointer-events-none).
 */
export const MovementAnswerFeedback: React.FC<Props> = ({ variant }) => {
  if (!variant) return null;

  const isOk = variant === 'correct';

  return (
    <div
      className="pointer-events-none fixed inset-0 z-[145] flex flex-col items-center justify-center overflow-hidden"
      aria-live="polite"
      aria-atomic="true"
    >
      {/* Flash nền */}
      <div
        className={`absolute inset-0 animate-pulse ${
          isOk ? 'bg-emerald-400/25' : 'bg-rose-500/20'
        }`}
        style={{ animationDuration: '0.55s' }}
      />

      {/* Hạt confetti đơn giản (CSS) */}
      {isOk &&
        Array.from({ length: 18 }).map((_, i) => (
          <span
            key={i}
            className="absolute h-2 w-2 rounded-sm opacity-90 motion-safe:animate-bounce"
            style={{
              left: `${8 + (i * 47) % 84}%`,
              top: `${12 + (i * 31) % 76}%`,
              background: ['#34d399', '#fbbf24', '#60a5fa', '#f472b6', '#a78bfa'][i % 5],
              animationDelay: `${(i % 6) * 0.05}s`,
              animationDuration: `${0.65 + (i % 4) * 0.08}s`,
            }}
          />
        ))}

      <div
        className={`relative z-10 flex max-w-sm scale-100 flex-col items-center rounded-[2rem] border-2 px-8 py-7 text-center shadow-2xl backdrop-blur-md animate-in zoom-in-95 duration-300 ${
          isOk
            ? 'border-emerald-300/80 bg-emerald-950/75 text-emerald-50'
            : 'border-rose-300/70 bg-rose-950/75 text-rose-50'
        }`}
      >
        <span className="mb-2 text-5xl drop-shadow-lg">{isOk ? '✨' : '💪'}</span>
        <span className="text-4xl font-black tracking-tight drop-shadow-md">{isOk ? 'Đúng rồi!' : 'Chưa đúng'}</span>
        <p className={`mt-2 text-sm font-bold ${isOk ? 'text-emerald-200/95' : 'text-rose-200/95'}`}>
          {isOk ? 'Giỏi lắm — cứ thế nhé!' : 'Thử lại hoặc chọn đáp án khác nhé!'}
        </p>
      </div>
    </div>
  );
};
